import React, { useEffect, useState } from "react";
import { Avatar, Button, List, Skeleton } from "antd";
import { LikeFilled, HeartFilled } from "@ant-design/icons";

const PAGE_SIZE = 3;

const defaultData = [
  {
    createdAt: "2025-04-26T19:13:38.338Z",
    name: "烟雨江南",
    avatar:
      "https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/male/512/12.jpg",
    gender: "female",
    email: "youngboizzz@gmail.com",
    city: "Lake Lorenzo",
    birthdate: "1955-04-13T21:25:22.777Z",
    id: "7",
    address: "Lake Lorenzo",
    description: "捷途产品矩阵不断丰富完善，优秀产品层出不穷",
    time: "2025-06-26 15:50:01",
  },
  {
    createdAt: "2025-04-27T03:03:49.295Z",
    name: "Labubu",
    avatar: "https://avatars.githubusercontent.com/u/63156927",
    gender: "male",
    email: "Lizeth_Hagenes@hotmail.com",
    city: "Franeckitown",
    birthdate: "1964-07-01T13:57:11.140Z",
    id: "8",
    description:
      "旅途，是我们到达各种终点的过程，胜利，不是到达，而是出发。“在路上”就是赢家，路上的风景就是战利品。",
    time: "2025-06-23 7:20:12",
  },
  {
    createdAt: "2025-04-27T12:14:11.838Z",
    name: "阳光少年",
    avatar: "https://avatars.githubusercontent.com/u/25132279",
    gender: "female",
    email: "Alva_Tillman@gmail.com",
    city: "North Aimee",
    birthdate: "1979-01-14T21:17:21.365Z",
    id: "9",
    description:
      "捷途汽车推出山海新能源产品序列,助力悦享生活的都市新生代，享受自在旅行。",
    time: "2025-06-11 17:50:33",
  },
];

const moreDta = [
  {
    createdAt: "2025-04-26T23:51:02.159Z",
    name: "幸福人生",
    avatar: "https://avatars.githubusercontent.com/u/98111059",
    gender: "female",
    email: "Yadira.Hilpert@yahoo.com",
    city: "Mosheberg",
    birthdate: "1985-03-02T09:07:14.212Z",
    id: "10",
    description:
      "捷途产品矩阵不断丰富完善，优秀产品层出不穷，在国内外市场均保持迅猛增长，创下了“成立五年累销破百万”、“成立第六年年销超50万”等记录，成为汽车行业的“现象级”范本",
    time: "2025-05-17 08:10:03",
  },
  {
    createdAt: "2025-04-27T07:28:30.043Z",
    name: "老干部",
    avatar: "https://avatars.githubusercontent.com/u/51559522",
    gender: "male",
    email: "Chasity_VonRueden@yahoo.com",
    city: "Gottliebcester",
    birthdate: "1998-03-08T11:10:37.645Z",
    id: "11",
    description:
      "捷途汽车，为当下年轻人制造彰显个性的生活好车，与年轻人一起，以旅行 见世界",
    time: "2025-06-29 17:50:33",
  },
  {
    createdAt: "2025-04-27T02:58:33.336Z",
    name: "5G冲浪",
    avatar: "https://avatars.githubusercontent.com/u/8711247",
    gender: "female",
    email: "Nelle_Boyle@gmail.com",
    city: "Kohlerstad",
    birthdate: "1965-04-11T18:16:56.851Z",
    id: "12",
    description:
      "旅途，是我们到达各种终点的过程，胜利，不是到达，而是出发。“在路上”就是赢家，路上的风景就是战利品。",
    time: "2025-06-05 10:34:00",
  },
];

const AutList = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(defaultData);
  const [list, setList] = useState(defaultData);
  const [page, setPage] = useState(1);

  const onLoadMore = () => {
    setLoading(true);
    if (page === 2) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      return;
    }
    setList(
      data.concat(
        Array.from({ length: PAGE_SIZE }).map(() => ({ loading: true }))
      )
    );
    const nextPage = page + 1;
    setPage(nextPage);
    setTimeout(() => {
      const newData = data.concat(moreDta);
      setData(newData);
      setList(newData);
      setLoading(false);
      window.dispatchEvent(new Event("resize"));
    }, 1000);
  };
  const loadMore = !loading ? (
    <div
      style={{
        textAlign: "center",
        marginTop: 12,
        height: 32,
        lineHeight: "32px",
      }}
    >
      <Button onClick={onLoadMore}>加载更多</Button>
    </div>
  ) : null;
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      loadMore={loadMore}
      dataSource={list}
      renderItem={(item) => (
        <List.Item
          actions={[
            <LikeFilled style={{ color: "#1677ff" }} />,
            <HeartFilled style={{ color: "#ff4d4f" }} />,
          ]}
        >
          <Skeleton avatar title={false} loading={item.loading} active>
            <List.Item.Meta
              avatar={<Avatar src={item.avatar} />}
              title={<a href="https://ant.design">{item.name}</a>}
              description={item.description}
            />
            <div>{item.time}</div>
          </Skeleton>
        </List.Item>
      )}
    />
  );
};
export default AutList;
